"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.regexYYYYMMDD = void 0;
exports.dateToYYYYMMDD = dateToYYYYMMDD;
exports.isValidDate = isValidDate;
const numberUtils_1 = require("./numberUtils");
exports.regexYYYYMMDD = /\d{4}\-(0?[1-9]|1[012])\-(0?[1-9]|[12][0-9]|3[01])*/;
function dateToYYYYMMDD(date) {
    if (!date) {
        return undefined;
    }
    return `${date.getFullYear()}-${(0, numberUtils_1.padWithZeros)(date.getMonth() + 1, 2)}-${(0, numberUtils_1.padWithZeros)(date.getDate(), 2)}`;
}
function isValidDate(date, month) {
    return date.getMonth() + 1 === month;
}
//# sourceMappingURL=dateUtils.js.map